// extracted by mini-css-extract-plugin
export default {"wrapper":"Tn5sBqII","fill":"t2mU1oP0"};